import React, { useEffect, useState } from "react";
import cryp from "./cryp.module.css";
import { format } from "date-fns";
import { useParams, Link } from "react-router";
import SafeHtml from "../../ComponentDash/SafeHtml/SafeHtml";
import {
  fetchAllPosts,
  imageUrl,
  convertToDate,
  getFirstNWords,
} from "../../Api/PostManApi";

const CryptoTwo = () => {
  //   window.location.reload();
  const { category } = useParams();
  const [categoryPosts, setCategoryposts] = useState([]);
  useEffect(() => {
    // window.location.reload();
    const getCategoryPost = async () => {
      try {
        const [categoryResult, allPosts] = await Promise.all([
          fetchAllPosts(category),
          fetchAllPosts(),
        ]);
        const posted =
          Array.isArray(categoryResult) && categoryResult.length > 0
            ? categoryResult
            : allPosts;
        setCategoryposts(posted);
        console.log(posted);

        // if(categoryResult){
        //     setCategoryposts(categoryResult)
        // }
      } catch (error) {
        console.log(error.message);
      }
    };
    getCategoryPost();
  }, [category]);
  return (
    <div className={cryp.cryp}>
      <div className={cryp.container}>
        <div className={cryp.content}>
          <div className={cryp.flex}>
            <div className={cryp.flexI}>
              <h3>{category}</h3>
              <img
                src={`${imageUrl}/post_images/${categoryPosts[0]?.images}`}
                alt=""
              />
              <div className={cryp.secI}>
                <h4 className={cryp.Date}>
                  {categoryPosts?.[0]
                    ? format(categoryPosts?.[0].createdAt, "d , MMM yyyy")
                    : format(new Date(), "d , MMM yyyy")}
                </h4>
                <h4>{category}</h4>
                <h4>
                  {categoryPosts[0]?.author?.name
                    ? `By ${categoryPosts[0].author.name}`
                    : ""}{" "}
                  {/* Fallback to default author */}
                </h4>{" "}
              </div>
              <Link to={`/${categoryPosts[0]?.slug}`}>
                <h2>{categoryPosts[0]?.title}</h2>
              </Link>
            </div>
            <div className={cryp.flexII}>
              {categoryPosts.slice(0, 4).map((category) => (
                <div className={cryp.secII} key={category?.slug}>
                  {/* <button>{category}</button> */}
                  <Link to={`/${category?.slug}`}>
                    <h5>{category?.title}</h5>
                  </Link>
                  <div className={cryp.aut}>
                    <h6>{convertToDate(category)}</h6>
                    <span> .</span>
                    <h6>{`By ${category?.author.name}`}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={cryp.flexIII}>
            <div className={cryp.grid}>
              <button>Related news</button>
              <div className={cryp.card}>
                {categoryPosts.slice(3, 7).map((post) => (
                  <div className={cryp.secIV}>
                    <img
                      src={`${imageUrl}/post_images/${post?.images}`}
                      alt=""
                    />
                    <h6>{convertToDate(post)}</h6>
                    <h3>{post?.title}</h3>
                    <Link to={`/${post?.slug}`}>
                      <SafeHtml html={getFirstNWords(post?.description)} />

                      {/* {post.description.split(/\s+/).length > 150} */}
                      <div style={{ "margin-bottom": " 24px" }}></div>
                      <span>More</span>
                    </Link>
                    {/* <p>
     x               {`${post?.description}`.}
                    <span>More</span>
                  </p> */}
                  </div>
                ))}

                {/* <div className={cryp.secIV}>
                  <img src={imgii} alt="" />
                  <h6>2hr Ago</h6>
                  <h3>
                    ChatGPT becomes a full-fledged search engine with web
                    integration
                  </h3>
                  <p>
                    As revealed on October 17, OpenAI has begun showing off a
                    Windows app for its AI chatbot, ChatGPT. Voice capabilities
                    and the most recent GPT-4o model have been added to the
                    official ChatGPT desktop client, which was released on MacOS
                    in June. Since then, the app has undergone multiple updates.
                    As of now, the new <span>More</span>
                  </p>
                </div>
              </div>
              <div className={cryp.card}>
                <div className={cryp.secIV}>
                  <img src={imgiv} alt="" />
                  <h6>2hr Ago</h6>
                  <h3>
                    Nigeria primed to become Africa’s AI powerhouse: VP Trixie
                    LohMirmand
                  </h3>
                  <p>
                    Trixie LohMirmand, Executive Vice President of the Duba
                    World Trade Centre, says Nigeria is a goldmine for
                    Artificial Intelligence that has the capacity to transform
                    the African continent. Speaking on Tuesday at the ongoing
                    GITEX Global 2024, the world’s largest tech gathering which
                    held in Dubai, Ms LohMirmand urged global investors not to{" "}
                    <span>More</span>
                  </p>
                </div>
                <div className={cryp.secIV}>
                  <img src={imgv} alt="" />
                  <h6>2hr Ago</h6>
                  <h3>
                    Nigeria poised to introduce $1.5 million AI assistance fund
                  </h3>
                  <p>
                    The Nigerian government, led by the Minister of
                    Communications, Innovation, and Digital Economy, Dr Bosun
                    Tijani, is poised to launch another $1.5 million support
                    fund dedicated to advancing Artificial Intelligence (AI) in
                    the country. This initiative aims to strengthen Nigeria’s AI
                    capabilities and foster innovation within the tech
                    ecosystem. The announcement comes in the wake{" "}
                    <span>More</span>
                  </p>
                </div> */}
              </div>
            </div>
            <div className={cryp.gridII}>
              <h2>ADS POST</h2>
            </div>
          </div>
          <div className={cryp.flexiv}>
            <div className={cryp.gridiii}>
              {categoryPosts.slice(7, 9).map((post) => (
                <div className={cryp.secIV}>
                  <img src={`${imageUrl}/post_images/${post?.images}`} alt="" />
                  <h6>{convertToDate(post)}</h6>
                  <h3>{post?.title}</h3>
                  <Link to={`/${post?.slug}`}>
                    <SafeHtml html={getFirstNWords(post?.description)} />

                    {/* {post.description.split(/\s+/).length > 150} */}

                    <div style={{ "margin-bottom": " 24px" }}></div>
                    <span>More</span>
                  </Link>
                  {/* <p>
     x               {`${post?.description}`.}
                    <span>More</span>
                  </p> */}
                </div>
              ))}
            </div>
            <div className={cryp.flexII}>
              {categoryPosts.slice(2, 6).map((category) => (
                <div className={cryp.secII} key={category?.slug}>
                  {/* <button>{category}</button> */}
                  <Link to={`/${category?.slug}`}>
                    <h5>{category?.title}</h5>
                  </Link>
                  <div className={cryp.aut}>
                    <h6>{convertToDate(category)}</h6>
                    <span> .</span>
                    <h6>{`By ${category?.author.name}`}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptoTwo;
